<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default {
  mounted() {
    this.setWidth();

    window.addEventListener("resize", () => {
      this.setWidth();
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", () => {
      this.setWidth();
    });
  },
  methods: {
    setWidth() {
      this.$store.commit("setWidth", window.innerWidth);
    },
    getParam(name) {
      // eslint-disable-next-line
      name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
      var regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
      var results = regex.exec(location.search);
      return results === null
        ? ""
        : decodeURIComponent(results[1].replace(/\+/g, " "));
    }
  }
};
</script>
<style lang="scss">
@font-face {
  font-family: "AmnestyTradeGothic";
  src: url("./assets/fonts/AmnestyTradeGothic-BdCn20.ttf"),
    url("./assets/fonts/AmnestyTradeGothic-BdCn20.woff") format("woff");
  font-weight: normal;
  font-style: normal;
}
*,
*:before,
*:after {
  box-sizing: border-box;
}
html,
body {
  margin: 0;
  background: url("./assets/image.jpg");
  background-attachment: fixed;
  background-size: cover;
  background-position: center;
  line-height: 1.4;
  background: black;
  font-family: "AmnestyTradeGothic";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

h1,
h2,
h3,
h4,
p {
  margin: 0 0 20px;
  font-family: "AmnestyTradeGothic";

  @media (max-width: 767px) {
    margin: 0 0 12px;
  }
}
h1,
h2,
h3,
h4 {
  font-family: "AmnestyTradeGothic";
  font-weight: 400;
}

a {
  color: white;
}

h1 {
  font-size: 2em;
  @media (max-width: 767px) {
    font-size: 1.65em;
  }
}

h2 {
  font-size: 1.5em;
  @media (max-width: 767px) {
    font-size: 1.35em;
  }
}

.button_wrap {
  display: flex;
  justify-content: center;

  @media (max-width: 767px) {
    display: flex;
    flex-wrap: wrap;
    padding-top: 5px;
  }
  button {
    margin: 10px;

    &:first-of-type {
      margin-left: 0;
    }
    &:last-of-type {
      margin-right: 0;
    }
    @media (max-width: 767px) {
      width: 100% !important;
      margin: 5px 0;
    }
  }

  &.two_wide {
    flex-wrap: wrap;
    @media (max-width: 767px) {
      margin: 0 -5px;
    }

    button {
      width: 50%;
      margin: 10px;
      @media (max-width: 767px) {
        width: calc(50% - 10px) !important;
        margin: 5px !important;
        min-width: initial !important;
      }
    }
  }
}

.desktop {
  @media (max-width: 767px) {
    display: none;
  }
}
.mobile {
  display: none;
  @media (max-width: 767px) {
    display: inherit;
  }
}
.spacing {
  height: 7px;
}
</style>
